import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import { useGetHomeBoxQuery } from "../../Store/api/CommonApi";

export default function FeatureComponent() {
  const { data } = useGetHomeBoxQuery();
  const itemComponent = useCallback(() => {
    if (data?.data.length > 0) {
      return data?.data.map((item, i) => {
        if (item?.visible) {
          return (
            <div className="col-lg-2 col-md-4 col-sm-6" key={i}>
                <Link
                  to={item.is_external ? item.url : "/jobs" + item.url}
                  //target={item.is_external ? "_blank" : "_self"}
                >
                <div className="single-fcat">
                    <img src={encodeURI(item.image)} alt={item.name} />
                    <p>{item.name}</p>
                </div>
              </Link>
              </div>
          );
        } else {
          return null;
        }
      });
    }
  }, [data]);
  return itemComponent();
}
